import AlertsSearch from 'Components/alerts/components/AlertsSearch';
import HeadingWithToolTip from 'Components/common/components/HeadingWithToolTip';
import DropWrapper from 'Components/people/components/DropWrapper';
import GroupsDisplayWidget from 'Components/people/components/GroupsDisplayWidget';
import { StaffBuyerGroupData } from 'Types/GroupsTypes';
import {
  SmartAccountTitleText, maxMobile, maxTablet, maxWidth, primaryColor, primaryFont,
  primaryHeadingColor, retina, scrollbar, secondaryFont, smMobile, wLight, wMBold, wMedium,
} from 'Utils/utilsStyle';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { actions as groupActions } from 'Slice/GroupsSlice';
import { usePrevious } from 'Utils/hooks/usePrevious';
import {
  selectAllLoading, selectEndedGroups, selectGroupsCount,
  selectIsDuplication, selectSearchedGroupsCount,
} from 'Selector/GroupsSelector';
import GroupsDisplaySkeleton from 'Components/common/skeleton/GroupsDisplaySkeleton';
import { actions } from 'Slice/CompaniesSlice';
import { selectAccountSelectedGroups, selectGroupsToShow, selectShowSelectedGroups } from 'Selector/CompaniesSelector';
import { actions as flurryActions } from 'Slice/HelperSlice';
import NoPersonsFound from 'Components/common/components/NoPersonsFound';
import { NO_GROUP_FOUND } from 'Utils/Constants';
import { formatNumberWithCommas, getCurrentTime, valueToObject } from 'Utils/UtilityFunctions';
import SmartAccountBuyerSearch from './SmartAccountBuyerSearch';

const Wrapper = styled.div`
 padding: 24px 40px 0px;
  @media all and (max-width: ${maxTablet}) {
    padding: 24px 10px 0px;
  }
.smart-heading-title-tooltip {
  display: flex;
  width: calc(100% - 15px);
  ${SmartAccountTitleText};
  @media all and (max-width: ${maxWidth}), ${retina} {
    font-size: 16px;
    line-height: 18px;
  }
  @media all and (max-width: ${maxMobile}) {
    font-size: 14px;
    line-height: 16px;
  }
  margin-bottom: 12px;
  .global-tooltip-element {
    position: relative;
    display: inline-flex;
    .section-detail-tip {
      .ant-tooltip {
        left: unset !important;
        right: 25px !important;
        top: 10px !important;
      }
    }
  }
}
.search-div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 15px);
  margin-bottom: 12px;
  .search-wrapper {
    width: calc(100% - 98px);
    max-width: 344px;
    height: 35px;
    z-index: 0;
    .ant-input-affix-wrapper {
      padding-left: 6px;
      padding-right: 32px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        padding-left: 11px;
      }
      height: 35px;
      max-width: 344px;
      .ant-input-prefix {
         padding: 0px 8px 0px 4px;
        @media all and (max-width: ${maxWidth}), ${retina} {
          padding: 0px 1px 0px 4px;
        }
        .search-global-icon-svg {
          width: 16px;
          @media all and (max-width: ${maxWidth}), ${retina} {
            width: 26px;
          }
          path {
            fill: ${primaryHeadingColor};
          }
        }
      }
      .ant-input::placeholder {
        font-weight: ${wLight} !important;
        color: #C1C1C1;
      }
    }
    .cross-icon {
      top: 10px;
      right: 10px;
      cursor: pointer;
      z-index: 1;
    }
  }
  .search-text {
    color: ${primaryColor};
    font-family: ${primaryFont};
    font-weight: ${wMedium};
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.4px;
    margin-left: 16px;
    cursor: pointer;
    @media all and (max-width: ${maxWidth}), ${retina} {
      font-size: 14px;
    }
  }
}
.buyer-group-div {
  .company-name-text {
    color: ${primaryHeadingColor};
    font-family: ${secondaryFont};
    font-size: 18px;
    font-weight: ${wMBold};
    line-height: 20px;
    letter-spacing: -0.562px;
    margin-bottom: 10px;
  }
  .search-result{
    display: flex;
    align-items: center;
    margin-top: 8px;
    margin-bottom: 0px;
    @media all and  (max-width: ${maxWidth}), ${retina}{
      margin-top: 20px;
      margin-bottom: 14px;
    }
    @media all and  (max-width: ${maxMobile}){
      margin-bottom: 0px;
    }
   .icon-span{
    margin-right: 13px;
    margin-top: 5px;
    margin-left: 11px;
    .c-pointer{
      width: 17px;
      height: 17px;
    }
   }
   .separator{
    margin-right: 5px;
    color: #dddddd;
   }
   .para-result{
    font-weight: ${wMBold};
    font-size: 14px;
    margin: 0px 10px;
    color: #1EC252;
    font-family: ${secondaryFont};
    @media all and (max-width: ${maxMobile}) {
      font-size: 14px;
      margin: 0px 5px;
    }
   }
 }
  .infinite-scroll-component__outerdiv {
    .groups-wrapper {
      margin: 0px;
      height: calc(100vh - 482px) !important;
      padding: 0px 10px 10px 0px;
      ${scrollbar};
      border-radius: 0px !important;
      @media all and (max-width: ${maxWidth}), ${retina} {
        height: calc(100vh - 423px) !important;
      }
      @media all and (max-width: ${maxTablet}) {
        height: calc(100vh - 478px) !important;
      }
      @media all and (max-width: ${smMobile}) {
        height: calc(100vh - 497px) !important;
      }
      .drop-person-area {
        .group-display-widget {
          min-height: unset;
          margin-bottom: 10px;
          .card-inner-wrapper {
            padding: 5px 0px;
            min-height: unset;
            .card-inner-div {
              justify-content: space-between;
              min-height: 70px;
              .add-remove-div {
                height: 18px;
                svg {
                  height: 20px;
                  width: 20px;
                }
              }
              .data-share-wrapper-div {
                .shared {
                  margin-right: 4px;
                  margin-bottom: 4px;
                }
                .share-delt-div {
                  display: none;
                }
              }
            }
          }
        }
      }
      .no-data-wrapper {
        height: calc(100%);
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        .no-person-found-wrapper {
          height: unset;
          .no-person-title {
            font-size: 20px;
            color: #7E7E7E;
            margin-bottom: 0px;
          }
        }
        .view-text {
          color: ${primaryColor};
          font-family: ${primaryFont};
          font-size: 16px;
          font-weight: ${wMBold};
          line-height: 24px;
          letter-spacing: -0.556px;
          cursor: pointer;
        }
      }
    }
  }
}
`;

type Props = {
  allGroups: StaffBuyerGroupData[],
  isActive: boolean,
};

const SmartAccountBuyerGroupTab = function SmartAccountBuyerGroupTab(props: Props) {
  const { allGroups, isActive } = props;
  const statement = 'Already created Buyer Groups can be selected to be included in the Buyer Group of the account plan.';
  const toolTipText = 'Explore your existing Buyer Groups and select any to be added to the final main Buyer Group in the Smart Account Plan document. You can also search for a specific person, and all Buyer Groups they are part of will be shown in the search results.<br/><br/>By selecting existing Buyer Groups and searching for specific individuals, you can enhance collaboration and ensure a comprehensive Buyer Committee in your Account Plan.';
  const [searchTerm, setSearchTerm] = useState('');
  const prevSearchTerm = usePrevious(searchTerm);
  const dispatch = useDispatch();
  const loading = useSelector(selectAllLoading);
  const ended = useSelector(selectEndedGroups);
  const isDuplication = useSelector(selectIsDuplication);
  const selectedGroups = useSelector(selectAccountSelectedGroups);
  const showSelectedGroups = useSelector(selectShowSelectedGroups);
  const groupsToShow = useSelector(selectGroupsToShow);
  const groupsCount = useSelector(selectGroupsCount);
  const formattedBuyerGroupCount = formatNumberWithCommas(groupsCount);
  const searchedGroupsCount = useSelector(selectSearchedGroupsCount);
  const formattedSearchedGroupCount = formatNumberWithCommas(searchedGroupsCount);

  const startTime = getCurrentTime();
  useEffect(() => {
    if (showSelectedGroups) {
      dispatch(actions.setGroupsToShow(selectedGroups));
    }
  }, [selectedGroups]);

  const onSearching = (keywords: string) => {
    setSearchTerm(keywords);
    dispatch(actions.setShowSelectedGroup(false));
    if (keywords === '') {
      dispatch(actions.setGroupsToShow(allGroups));
      if (prevSearchTerm?.length) {
        // dispatch(groupActions.getAllGroups({ offset: groupsToShow.length }));
      }
    } else {
      dispatch(groupActions.getAllGroups({ offset: 0, searchTerm: keywords }));
      dispatch(flurryActions.callFlurryEvent(
        valueToObject(`accountPlan_clickBuyerGroupSearch_${keywords}`, startTime, {}),
      ));
    }
  };

  const fetchMore = () => {
    if (searchTerm === '' && !ended
      // && showSelectedGroupsText
      && groupsToShow.length && !showSelectedGroups) {
      dispatch(groupActions.getAllGroups({ offset: groupsToShow.length }));
    }
  };

  useEffect(() => {
    if (showSelectedGroups) {
      dispatch(actions.setGroupsToShow(selectedGroups));
    } else if (searchTerm === '') {
      dispatch(actions.setGroupsToShow(allGroups));
    }
  }, [showSelectedGroups]);

  const toggleSelected = () => {
    dispatch(actions.setGroupsToShow([]));
    dispatch(actions.setShowSelectedGroup(!showSelectedGroups));
  };

  const handleAddGroup = (group: StaffBuyerGroupData) => {
    dispatch(actions.addAccountSelectedGroup(group));
    dispatch(flurryActions.callFlurryEvent(
      valueToObject(`accountPlan_clickAddBuyerGroup_${group.groupId}`, startTime, {}),
    ));
    dispatch(flurryActions.setNotification({
      message: `${group?.groupName} has been added successfully`,
      proTip: false,
      rightPlacement: false,
      groupId: 0,
      classnameFlag: true,
    }));
  };

  const handleRemoveGroup = (group: StaffBuyerGroupData) => {
    dispatch(actions.removeAccountSelectedGroup(group));
    dispatch(flurryActions.callFlurryEvent(
      valueToObject(`accountPlan_clickRemovedBuyerGroup_${group.groupId}`, startTime, {}),
    ));
    dispatch(flurryActions.setNotification({
      message: `${group?.groupName} has been removed successfully`,
      proTip: false,
      rightPlacement: false,
      groupId: 0,
      classnameFlag: true,
    }));
  };

  const handleView = () => {
    setSearchTerm('');
    dispatch(actions.setGroupsToShow(allGroups));
  };

  return (
    <Wrapper className={classNames({ dNone: !isActive })}>
      <h1 className="smart-heading-title-tooltip">
        {statement}
        <HeadingWithToolTip
          heightIcon="19px"
          widthIcon="16px"
          heightIconSm="20px"
          widthIconSm="13px"
          customWidth="280px"
          toolTipText={toolTipText}
          exampleText=""
          toolPlacement="bottomRight"
          midTabletFlag
          htmlFlag
        />
      </h1>
      <div className="search-div">
        <AlertsSearch
          placeholderText="Filter and search groups..."
          loading={loading && !allGroups?.length}
          query={searchTerm}
          onSearching={onSearching}
          margin="0px"
          height="30px"
        />
        <span
          className={classNames('search-text text-truncate', { disabled: loading })}
          onClick={toggleSelected}
          onKeyPress={toggleSelected}
          role="button"
          tabIndex={-1}
        >
          {showSelectedGroups ? 'Back' : `Selected (${selectedGroups?.length})`}
        </span>
      </div>
      <div className="buyer-group-div">
        {searchTerm.length && !showSelectedGroups && !loading ? <h3 className="company-name-text text-truncate">{`Matching Buyer Groups (${formattedSearchedGroupCount})`}</h3> : null}
        {searchTerm === '' && !showSelectedGroups ? <h3 className="company-name-text text-truncate">{`Buyer Groups (${formattedBuyerGroupCount})`}</h3> : null}
        {showSelectedGroups ? <h3 className="company-name-text text-truncate">{`Selected Buyer Groups (${selectedGroups?.length})`}</h3> : null}
        {searchTerm === '' || showSelectedGroups ? (
          <InfiniteScroll
            hasMore
            dataLength={groupsToShow?.length ?? 0}
            next={fetchMore}
            loader={false}
            height="auto"
            className={classNames('groups-wrapper')}
          >
            {groupsToShow?.map((group) => (
              <DropWrapper
                key={group.groupId}
              >
                <GroupsDisplayWidget
                  onClickHandler={() => { }}
                  groupPersona={group.groupPersonality}
                  persons={group.persons}
                  companies={group.companyLogos}
                  groupName={group.groupName}
                  groupId={group.groupId}
                  personsCount={group.personsCount}
                  isShared={group.groupShared}
                  sharedBy={group.sharedByFirstName}
                  showAddIcon
                  onClickAdd={() => handleAddGroup(group)}
                  onClickRemove={() => handleRemoveGroup(group)}
                />
              </DropWrapper>
            ))}
            {(loading && !ended && !isDuplication)
              || (!showSelectedGroups && groupsToShow?.length < allGroups?.length)
              ? <GroupsDisplaySkeleton border /> : null}
            {groupsToShow?.length < 1 && !loading
              ? (
                <div className="no-data-wrapper">
                  {showSelectedGroups ? (
                    <>
                      <NoPersonsFound title="No Buyer Group Selected" />
                      <span
                        className="view-text"
                        onClick={toggleSelected}
                        onKeyPress={toggleSelected}
                        role="button"
                        tabIndex={-1}
                      >
                        View Groups
                      </span>
                    </>
                  ) : null}
                  {!showSelectedGroups && !allGroups?.length ? <NoPersonsFound title={showSelectedGroups ? 'No Buyer Group Selected' : NO_GROUP_FOUND} /> : null}
                </div>
              ) : null}
          </InfiniteScroll>
        ) : (
          <SmartAccountBuyerSearch
            searchTerm={searchTerm}
            handleView={handleView}
            handleAddGroup={handleAddGroup}
            handleRemoveGroup={handleRemoveGroup}
          />
        )}
      </div>
    </Wrapper>
  );
};

export default SmartAccountBuyerGroupTab;
